import { DefaultButton, Dialog, PrimaryButton, Stack } from "office-ui-fabric-react"
import { useHistory } from "react-router"
import { newFloorplanLayoutFromBlank, newFloorplanLayoutFromPrevious } from "../../../api/floorplans";
import { IFloorplan, IFloorplanAddResult } from "../../../types/SiteLocation.types";

export interface INewLayoutDialogProps {
    floorplan: Partial<IFloorplan>;
    onDismiss: () => void;
    onError: (error: string) => void;
}

export const NewLayoutDialog = (props: INewLayoutDialogProps) => {
    const history = useHistory();

    const _newLayout = async (floorplan: Partial<IFloorplan>, fromBlank: boolean) => {
        if (floorplan.Id) {
            const response = fromBlank ? await newFloorplanLayoutFromBlank(floorplan.Id) :
                await newFloorplanLayoutFromPrevious(floorplan.Id);
            if (response.ok) {
                const info = await response.json() as IFloorplanAddResult;
                history.push(`/admin/layoutEditor/floorplan/${info.floorplanId}/${info.layoutId}`);
            } else {
                props.onError("Unable to create new floorplan layout: " + response.statusText);
                props.onDismiss();
            }
        }
    }

    return (
        <Dialog hidden={false} dialogContentProps={{
            title: "Edit Layout",
            onDismiss: props.onDismiss,
            showCloseButton: true,
        }}>
            <p>
                You can amend the previously published layout for this floorplan or start with a blank layout.
                Using a clear layout should only be done if you are setting up desks for the first time. If you overwrite
                a layout with fewer/no desks, future bookings for this floorplan may no longer be valid.
            </p>
            <Stack horizontal horizontalAlign="space-around">
                <PrimaryButton style={{marginRight: 20, height: 50}} iconProps={{iconName: "Nav2DMapView"}} text="Use Previous Layout" onClick={() => { _newLayout(props.floorplan, false); }} />
                <DefaultButton style={{height: 50}} iconProps={{iconName: "Broom"}} text="Start Blank" onClick={() => { _newLayout(props.floorplan, true); }} />
            </Stack>
        </Dialog>
    )
}